/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingPeriodMemoryForEksAgent extends models.CostProcessingPeriodMemoryForKubernetesAgent {
    getFixupPrototypeFunction() { return CostProcessingPeriodMemoryForEksAgent.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingPeriodMemoryForEksAgent>): CostProcessingPeriodMemoryForEksAgent {
        let obj = Object.assign(new CostProcessingPeriodMemoryForEksAgent(), model);
        CostProcessingPeriodMemoryForEksAgent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingPeriodMemoryForEksAgent>): CostProcessingPeriodMemoryForEksAgent {
        if (!model) return null;
        return CostProcessingPeriodMemoryForEksAgent.newInstance(<CostProcessingPeriodMemoryForEksAgent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingPeriodMemoryForEksAgent) {
        if (!obj) return;

        models.CostProcessingPeriodMemoryForEksAgent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingPeriodMemoryForEksAgent): boolean {
        if (models.CostProcessingPeriodMemoryForKubernetesAgent.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingPeriodMemoryForEksAgent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
